import { lazy } from "react";
import { PRACTICE_ROLE } from "./routeConfig";

const practiceRoutes = [
  {
    path: "/practice/dashboard",
    component: lazy(() => import("../Pages/Practice/Dashboard")),
    isPublic: false,
    exact: true,
    role: [PRACTICE_ROLE],
  }
];

export default practiceRoutes;
